import { render, staticRenderFns } from "./createPriceRegion.vue?vue&type=template&id=86b9c040"
import script from "./createPriceRegion.vue?vue&type=script&lang=js"
export * from "./createPriceRegion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports